import React, { useState } from 'react';

const GameOver = ({ gameState, setGameState, answerArray }) => {
    const [copySuccess, setCopySuccess] = useState('');

    const handleExit = () => {          
        setGameState(prevState => ({
            ...prevState,
            atEndScreen: false
        }));
    };

    function createGameOverString(){
        const emoji0 = answerArray[0]?.emoji || ''; 
        const emoji1 = answerArray[1]?.emoji || ''; 
        const emoji2 = answerArray[2]?.emoji || ''; 
        const emoji3 = answerArray[3]?.emoji || ''; 
        const emoji4 = answerArray[4]?.emoji || ''; 
        const emoji5 = answerArray[5]?.emoji || ''; 
        let string2return = `Medi-Guesser #${gameState.gameNumber} \nScore: ${gameState.points} \n${emoji0} ${emoji1}\n${emoji2} ${emoji3}\n${emoji4} ${emoji5}\n\nCheck it out here: https://mediguesser.com`
        return string2return
    }

    const createGameOverJSX = () => {
        const emoji0 = answerArray[0]?.emoji || ''; 
        const emoji1 = answerArray[1]?.emoji || ''; 
        const emoji2 = answerArray[2]?.emoji || ''; 
        const emoji3 = answerArray[3]?.emoji || ''; 
        const emoji4 = answerArray[4]?.emoji || ''; 
        const emoji5 = answerArray[5]?.emoji || ''; 
    
        return (
            <>
                Thank you for playing!<br />
                Score: {gameState.points}<br />
                {emoji0}  {emoji1}<br />
                {emoji2}  {emoji3}<br />
                {emoji4}  {emoji5}
            </>
        );
    };

    const handleCopy = () => {
        const scoreString = createGameOverString();
    
        if (navigator.clipboard) {
            navigator.clipboard.writeText(scoreString)
                .then(() => setCopySuccess('Copied!'))
                .catch(() => setCopySuccess('Failed to copy.'));
        } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = scoreString;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            setCopySuccess('Copied!');
        }
    };

    return (
        <>
            <div className="game-over-overlay" />
            <div className="game-over-screen">
                <p>{createGameOverJSX()}</p>
                <button onClick={handleCopy}>Copy</button>
                {copySuccess && <p>{copySuccess}</p>}
                <button onClick={handleExit}>Exit</button>
            </div>
        </>
    );
};

export default GameOver;
